import * as React from 'react';

import { CoworkingHelper as CoworkingHelperComponent } from './CoworkingHelper';

interface ICoworkingHelper {
  className?: string;
}

export const CoworkingHelper: React.FC<ICoworkingHelper> = props => {
  return <CoworkingHelperComponent {...props} />;
};

CoworkingHelper.displayName = 'CoworkingHelperContainer';
